import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/CancelOutlined';
import AddInputIcon from '@material-ui/icons/PlaylistAdd';
import TextField from '@material-ui/core/TextField';
import {CompactPicker} from 'react-color';
import Switch from '@material-ui/core/Switch';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {observer} from "mobx-react";

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 20,
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        paddingRight: theme.spacing.unit * 2
    },
    card: {
        maxWidth: 300,
    },
    media: {
        height: 300,
    },
    paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        textAlign: 'center'
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
    },
    warningButton: {
        margin: theme.spacing.unit,
        color: "white",
        backgroundColor: "#E9190F",
        '&:hover': {
            backgroundColor: "#E9190F",
        },
    },
    buttonProgress: {
        color: '#D64D29',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    }
});

class ProductLandingpage extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            deleteModal: false,
            uuidToDelete: ""
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSafetyCheckInputChange = this.handleSafetyCheckInputChange.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal(uuid)
    {
        this.setState({
            deleteModal: !this.state.deleteModal,
            uuidToDelete: uuid
        });
    }

    handleInputChange(index, event)
    {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        if (name === "options")
        {
            this.props.productStore.inputs[index][name] = JSON.stringify(value.split(";"))
        } else
        {
            this.props.productStore.inputs[index][name] = value;
        }
    }

    handleColorChangeComplete = (index, color) =>
    {
        this.props.productStore.inputs[index]["text_color"] = color.hex;
    };

    handleSafetyCheckInputChange(event)
    {
        const target = event.target;
        const value = target.value;
        this.setState({safetyCheckWord: value})
        if (value === this.props.productStore.product.productid)
        {
            this.setState({safetyCheckPassed: true})
        } else
        {
            this.setState({safetyCheckPassed: false})
        }
    }

    saveInput(index)
    {
        this.props.productStore.saveInput(this.props.match.params.id, index);
    }

    deleteInput(uuid)
    {
        this.props.productStore.deleteInput(this.props.match.params.id, uuid);
        this.setState({
            deleteModal: !this.state.deleteModal
        });
    }

    addInput()
    {
        this.props.productStore.addInput(this.props.match.params.id);
    }

    componentDidMount()
    {
        this.props.productStore.getInputList(this.props.match.params.id);
    }

    render()
    {
        const {classes} = this.props;

        return (
            <div>
                <ToastContainer/>
                <Dialog
                    open={this.state.deleteModal}
                    onClose={this.toggleModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">Eingabefeld löschen</DialogTitle>
                    <DialogContent>
                        Soll das Eingabefeld wirklich gelöscht werden?
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" size="small" color="primary" onClick={this.toggleModal} className={classes.button}>
                            <CancelIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                            Abbrechen
                        </Button>
                        <Button variant="contained" size="small" color="secondary" onClick={() => this.deleteInput(this.state.uuidToDelete)}
                                className={classes.warningButton}>
                            <DeleteIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                            Löschen
                        </Button>
                    </DialogActions>
                </Dialog>
                <Typography variant="headline" gutterBottom>
                    Eingabefelder für Produkt {this.props.productStore.product.name}
                </Typography>
                <form noValidate autoComplete="off">
                    {this.props.productStore.inputs.map((item, index) =>
                        <div key={index}>
                            <Paper>
                                <Grid container
                                      direction="row"
                                      justify="flex-start"
                                      alignItems="flex-start">
                                    <Grid item xs={3}>
                                        <TextField
                                            id="type"
                                            name="type"
                                            label="Feldtyp"
                                            select
                                            className={classes.textField}
                                            value={item.type || "text"}
                                            onChange={this.handleInputChange.bind(this, index)}
                                            SelectProps={{
                                                native: true,
                                                MenuProps: {
                                                    className: classes.menu,
                                                },
                                            }}
                                            margin="dense"
                                            fullWidth>
                                            <option value="text">Freitext</option>
                                            <option value="text-multiline">Freitext (Mehrzeilig)</option>
                                            <option value="number">Zahl</option>
                                            <option value="email">E-Mail Adresse</option>
                                            <option value="phone">Telefonnummer</option>
                                            <option value="dropdown">Dropdown</option>
                                            <option value="date">Datum</option>
                                            <option value="time">Uhrzeit</option>
                                            <option value="radio" disabled>Entweder/Oder</option>
                                            <option value="editor" disabled>Editor</option>
                                            <option disabled>---</option>
                                            <option value="layout">Layout-Element</option>
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            id="label"
                                            name="label"
                                            label={item.type === "layout" ? "Text des Layout-Elements" : "Label/Name des Eingabefeldes"}
                                            className={classes.textField}
                                            value={item.label || ''}
                                            onChange={this.handleInputChange.bind(this, index)}
                                            margin="dense"
                                            fullWidth
                                            disabled={item.html_element === "hr"}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            id="placeholder"
                                            name="placeholder"
                                            label="Platzhalter"
                                            className={classes.textField}
                                            value={item.placeholder || ''}
                                            onChange={this.handleInputChange.bind(this, index)}
                                            margin="dense"
                                            fullWidth
                                            disabled={item.type === "dropdown" || item.type === "radio" || item.type === "editor" || item.type === "layout"}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            id="information"
                                            name="information"
                                            label="Informationen"
                                            className={classes.textField}
                                            value={item.information || ''}
                                            onChange={this.handleInputChange.bind(this, index)}
                                            margin="dense"
                                            fullWidth
                                            disabled={item.type === "layout"}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container
                                      direction="row"
                                      justify="flex-start"
                                      alignItems="flex-start">
                                    <Grid item xs={11}>
                                        <TextField
                                            id="options"
                                            name="options"
                                            label="Auswahlmöglichkeiten/Optionen"
                                            placeholder="Blau;Grün;Rot"
                                            className={classes.textField}
                                            value={item.options ? JSON.parse(item.options).join(";") : ''}
                                            onChange={this.handleInputChange.bind(this, index)}
                                            margin="dense"
                                            fullWidth
                                            disabled={item.type !== "dropdown" && item.type !== "radio"}
                                        />
                                    </Grid>
                                    <Grid item xs={1}>
                                        <TextField
                                            id="displayorder"
                                            name="displayorder"
                                            label="Reihenfolge"
                                            className={classes.textField}
                                            value={item.displayorder || ''}
                                            onChange={this.handleInputChange.bind(this, index)}
                                            margin="dense"
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container
                                      direction="row"
                                      justify="flex-start"
                                      alignItems="flex-start">
                                    <Grid item xs={2}>
                                        <TextField
                                            id="html_element"
                                            name="html_element"
                                            label="Schrifttyp"
                                            select
                                            className={classes.textField}
                                            value={item.html_element || "span"}
                                            onChange={this.handleInputChange.bind(this, index)}
                                            SelectProps={{
                                                native: true,
                                                MenuProps: {
                                                    className: classes.menu,
                                                },
                                            }}
                                            margin="dense"
                                            fullWidth>
                                            <option value="span">Standard</option>
                                            <option value="h1">Überschrift 1</option>
                                            <option value="h2" disabled={item.visible !== 1}>Überschrift 2</option>
                                            <option value="h3" disabled={item.visible !== 1}>Überschrift 3</option>
                                            <option value="h4" disabled={item.visible !== 1}>Überschrift 4</option>
                                            <option value="h5" disabled={item.visible !== 1}>Überschrift 5</option>
                                            <option value="h6" disabled={item.visible !== 1}>Überschrift 6</option>
                                            <option value="hr" disabled={item.type !== "layout" || item.visible !== 1}>Trennlinie</option>
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    id="centered"
                                                    name="centered"
                                                    color="primary"
                                                    checked={!!+item.centered}
                                                    onChange={this.handleInputChange.bind(this, index)}
                                                    value="centered"
                                                    size="small"
                                                    inputProps={{'aria-label': 'secondary checkbox'}}
                                                    disabled={item.html_element === "hr" || item.visible !== 1}
                                                />
                                            }
                                            label="Zentriert"
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    id="bold"
                                                    name="bold"
                                                    color="primary"
                                                    checked={!!+item.bold}
                                                    onChange={this.handleInputChange.bind(this, index)}
                                                    value="bold"
                                                    size="small"
                                                    inputProps={{'aria-label': 'secondary checkbox'}}
                                                    disabled={item.html_element === "hr" || item.visible !== 1}
                                                />
                                            }
                                            label="Fettgedruckt"
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    id="show_label"
                                                    name="show_label"
                                                    color="primary"
                                                    checked={!!+item.show_label}
                                                    onChange={this.handleInputChange.bind(this, index)}
                                                    value="show_label"
                                                    size="small"
                                                    inputProps={{'aria-label': 'secondary checkbox'}}
                                                    disabled={item.html_element === "hr" || item.type === "layout" || item.visible !== 1}
                                                />
                                            }
                                            label="Label anzeigen"
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    id="delimiter"
                                                    name="delimiter"
                                                    color="primary"
                                                    checked={!!+item.delimiter}
                                                    onChange={this.handleInputChange.bind(this, index)}
                                                    value="delimiter"
                                                    size="small"
                                                    inputProps={{'aria-label': 'secondary checkbox'}}
                                                    disabled={item.html_element === "hr" || item.visible !== 1}
                                                />
                                            }
                                            label="Trennstrich anzeigen"
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    id="visible"
                                                    name="visible"
                                                    color="primary"
                                                    checked={!!+item.visible}
                                                    onChange={this.handleInputChange.bind(this, index)}
                                                    value="visible"
                                                    size="small"
                                                    inputProps={{'aria-label': 'secondary checkbox'}}
                                                />
                                            }
                                            label="Auf Infoseite anzeigen"
                                        />
                                    </Grid>
                                </Grid>
                                {item.type === "layout" &&
                                    <Grid container
                                          direction="row"
                                          justify="flex-start"
                                          alignItems="flex-start">
                                        <Grid item style={{marginLeft: "10px"}}>
                                            <hr/>
                                            <Typography>Textfarbe des Layout-Elements</Typography>
                                            <CompactPicker color={item.text_color || '#FFFFFF'}
                                                           onChangeComplete={this.handleColorChangeComplete.bind(this, index)}/>
                                        </Grid>
                                    </Grid>
                                }
                                <hr/>
                                <Grid container
                                      direction="row"
                                      justify="flex-end"
                                      alignItems="flex-start">
                                    <Grid item style={{marginRight: "6px"}}>
                                        <Button variant="contained" size="small" color="default" onClick={() => this.toggleModal(item.uuid)}
                                                className={classes.warningButton}>
                                            <DeleteIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                            Löschen
                                        </Button>
                                        <Button variant="contained" size="small" color="secondary" onClick={() => this.saveInput(index)}>
                                            <SaveIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                            Speichern
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Paper>
                            <hr/>
                        </div>
                    )}
                    <Grid container spacing={16}>
                        <Grid item>
                            <br/>
                            <Button variant="contained" size="small" color="primary" onClick={() => this.addInput()} className={classes.button}>
                                <AddInputIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                Feld hinzufügen
                            </Button>
                        </Grid>
                    </Grid>
                    <hr/>
                </form>
            </div>
        );
    }
}

export default withStyles(styles)(observer(ProductLandingpage));
